import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=db330b84&"
import script from "./PageHeading.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageHeading.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports